import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setAddTeacherLoading,
    setAddTeacherError,
    setAddTeacherSuccess,
    setAddTeacherResponse,
    setAddTeacherIsRoleUpdate,
} from "../reducers/addTeacherReducer";

export interface TeacherInviteItem {
    email?: string;
    id?: string | number;
    role?: string;
}

export interface RoleUpdatePayload {
    id: string | number;
    role: string;
}

const addTeacher =
    (courseId: string | number, teachers: TeacherInviteItem[] | RoleUpdatePayload, token: string, isRoleUpdate = false) =>
        async (dispatch: Dispatch) => {
            dispatch(setAddTeacherLoading(true));
            dispatch(setAddTeacherError(null));
            dispatch(setAddTeacherIsRoleUpdate(!!isRoleUpdate));

            const requestConfig = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            };

            try {
                if (isRoleUpdate) {
                    const single = Array.isArray(teachers) ? teachers[0] : teachers;
                    const id = single && typeof single === "object" && "id" in single ? single.id : undefined;
                    const role = single && typeof single === "object" ? (single.role || "editor") : "editor";
                    const roleLower = role.toLowerCase();

                    if (roleLower === "remove_user") {
                        const payload = { id: String(id ?? "") };
                        const result = await api.delete(
                            `courses/${courseId}/add-teacher/`,
                            { ...requestConfig, data: payload }
                        );
                        const data = result?.data ?? {};
                        dispatch(setAddTeacherResponse(data));
                        dispatch(setAddTeacherSuccess(true));
                    } else {
                        const payload = {
                            id: String(id ?? ""),
                            teacher_collaborator_roles: roleLower,
                        };
                        const result = await api.put(
                            `courses/${courseId}/add-teacher/`,
                            payload,
                            requestConfig
                        );
                        const data = result?.data ?? {};
                        dispatch(setAddTeacherResponse(data));
                        dispatch(setAddTeacherSuccess(true));
                    }
                } else {
                    const list = Array.isArray(teachers) ? teachers : [];
                    const collaborators = list.map((item) => {
                        const email = typeof item === "string" ? item : item.email;
                        const role = typeof item === "string" ? "editor" : (item.role || "editor");
                        const teacher_collaborator_roles = role.toLowerCase();
                        return { email, teacher_collaborator_roles };
                    });
                    const result = await api.post(
                        `courses/${courseId}/add-teacher/`,
                        { collaborators },
                        requestConfig
                    );
                    const data = result?.data ?? {};
                    dispatch(setAddTeacherResponse(data));
                    dispatch(setAddTeacherSuccess(true));
                }
            } catch (error: any) {
                const data = error?.response?.data;
                if (data && (data.detail || data.errors)) {
                    dispatch(setAddTeacherResponse(data));
                }
                const message =
                    data?.detail ||
                    data?.message ||
                    data?.error ||
                    "Failed to add teacher(s).";
                dispatch(setAddTeacherError(message));
            }
        };

export { addTeacher };
export { resetAddTeacher } from "../reducers/addTeacherReducer";
